import React from 'react';
import { Box, Card, CardContent, Grid, IconButton, Paper, Typography } from '@mui/material';
import { Close } from '@mui/icons-material';

interface DocumentContentViewerProps {
  content: string;
  isMobile: boolean;
  onClose: () => void;
}

export function DocumentContentViewer({
  content,
  isMobile,
  onClose,
}: DocumentContentViewerProps): React.ReactElement {
  return (
    <Grid size={{ xs: 12 }}>
      <Card variant="outlined">
        <CardContent sx={{ p: { xs: 1.5, sm: 3 } }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mb: 2,
            }}
          >
            <Typography variant={isMobile ? 'subtitle2' : 'h6'}>Document Content</Typography>
            <IconButton size="small" onClick={onClose}>
              <Close />
            </IconButton>
          </Box>
          <Paper
            variant="outlined"
            sx={{
              p: 2,
              maxHeight: 400,
              overflow: 'auto',
              backgroundColor: 'grey.50',
            }}
          >
            <pre
              style={{
                margin: 0,
                fontFamily: 'monospace',
                fontSize: isMobile ? '0.75rem' : '0.875rem',
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
              }}
            >
              {content || 'Loading content...'}
            </pre>
          </Paper>
        </CardContent>
      </Card>
    </Grid>
  );
}
